export default function ActionYM() {
  const actions = document.querySelectorAll('a[href="#appointment"][data-action-id]');

  actions.forEach((action) => action.addEventListener('click', (e) => {
    const { actionId } = e.target.dataset;

    if (!actionId) {
      return;
    }

    const appointmentFormElement = document.querySelector('#appointment #appointment-form-template');

    if (appointmentFormElement) {
      appointmentFormElement.dataset.actionId = actionId;
    }
  }));
}
